import { CircularProgress } from '@material-ui/core'
import { FC, CSSProperties } from 'react'

export type GlobalSpinnerProps = {
  size?: number
  color?: string
  className?: string
}

const overlayStyle: CSSProperties = {
  position: 'fixed',
  top: 0,
  left: 0,
  width: '100vw',
  height: '100vh',
  backgroundColor: 'rgba(255,255,255,0.85)',
  padding: 0,
  zIndex: 2000,
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center'
}

const GlobalSpinner: FC<GlobalSpinnerProps> = ({
  size = 64,
  color = '#4f9b44',
  className
}) => (
  <div className={className} style={overlayStyle}>
    <CircularProgress size={size} style={{ color }} />
  </div>
)

export default GlobalSpinner
